export {
  PROMO_CONFIG,
  PROMO_CAMPAIGN_STATUS,
  PROMO_SURFACES,
} from './promoConfig';
export { promoEnvFlags } from '../../config/promoEnvFlags';
export { canShowPromotion } from './promotionLifecycle';
export {
  getLastShownTimestamp,
  setLastShownTimestamp,
  isCooldownExpired,
} from './promoStorage';
